import styled from 'styled-components';

export const Container = styled.div`
  .btn-hide-search {
    right: -30px;
    top: 20px;
    height: 60px;
    width: 60px;
    background: ${(props) => props.theme.$white};
    border-radius: 100%;
    padding: 6px 5px 0 0;
    text-align: right;
    transition: all 1s;

    @media only screen and (max-width: 768px) {
      display: none;
    }

    i {
      transform: rotate(180deg);
    }

    &:hover {
      background: ${(props) => props.theme.$white};
    }
  }

  .hide-bar {
    .btn-hide-search {
      i {
        transform: rotate(0deg);
      }
    }
  }

  .btn-hide-documents {
    right: -30px;
    top: 20px;
    height: 34px;
    width: 30px;
    background-color: ${(props) => props.theme.$primary_green} !important;
    border-radius: 0 5px 5px 0;
    text-align: right;
    transition: all 1s;
  }

  .filter {
    &-button {
      @extend .shadow;
    }

    @media (min-width: 992px) {
      &-bar {
        position: fixed;
        top: 3.5em;
        left: 5px;
        height: 100%;
        background: ${(props) => props.theme.$white};
        border-right: 1px solid ${(props) => props.theme.$gray300};
        z-index: 13;
        transition: all 1s;

        &.hasTopBanner {
          top: 136px;

          .filter-form {
            max-height: calc(100% - 185px);
          }
        }

        &.hide-bar {
          transform: translateX(-100%);
        }
      }

      &-form {
        max-height: calc(100% - 165px);
        overflow-x: hidden;
        overflow-y: scroll;
        position: relative;

        &::-webkit-scrollbar {
          -webkit-appearance: none;
          width: 7px;

          &-thumb {
            border-radius: 4px;
            background-color: rgba(0, 0, 0, 0.5);
            -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
          }
        }
      }

      &-button {
        position: fixed;
        bottom: 0;
        left: 10px;
      }

      &-form-acoes {
        position: sticky;
        top: 0px;
        z-index: 10;
        background-color: #fff;
        padding-bottom: 10px;
      }
    }
  }

  .flash-message-notification {
    padding-left: 25%;

    @media only screen and (max-width: 768px) {
      padding-left: 0;
    }
  }

  .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
    transform: translateX(1.75rem);
  }

  .custom-control {
    width: 53px;
  }

  .custom-switch .custom-control-label::before {
    width: 50px;
    height: 25px;
    margin-top: -4px;
  }

  .custom-switch .custom-control-label::after {
    width: 20px;
    height: 20px;
    top: 2px;
  }

  .search-delete {
    margin: 15px 0px 0px 0px;
    text-decoration: underline;
    background: none;
    border: none;
    cursor: pointer;
  }

  .filter-active {
    pointer-events: none;
    opacity: 60%;
  }
`;
